import { DataSourceTable } from 'src/constants/dataSourceTable';
import { MAX_DATA_SOURCE_PREVIEW_ROWS } from 'src/constants/limits';
import { ProjectVirtualGraphOptions } from 'src/store/state/projects';
import { generateQualifiedTableName } from 'src/utils/generateQualifiedTableName';

export const generateSqlQueryForTable = ({
  limit,
  nativeQuoteCharacter,
  options,
  table,
}: {
  limit?: boolean;
  nativeQuoteCharacter: string | null;
  options: ProjectVirtualGraphOptions;
  table: DataSourceTable;
}) => {
  const qualifiedTableName = generateQualifiedTableName({
    nativeQuoteCharacter,
    options,
    table,
  });
  const base = `SELECT * FROM ${qualifiedTableName}`;
  return limit ? `${base} LIMIT ${MAX_DATA_SOURCE_PREVIEW_ROWS}` : base;
};
